import { Card } from '@material-ui/core'
import Alert from 'elements/Alert'
import { useTranslate } from 'ra-core'
import React from 'react'
import { useFormState } from 'react-final-form'
import PandadocSettingsSection from 'resources/contracts/PandadocSettingsSection'
import { useResourceStyles } from 'resources/styles'

interface PropTypes {
  disabled: boolean
}

const PandadocSettings: React.FC<PropTypes> = ({ disabled }) => {
  const resourceStyles = useResourceStyles()
  const translate = useTranslate()
  const formState = useFormState()
  const error = formState.errors?.enable_pandadoc_countersignature

  return (
    <>
      {error && (
        <div style={{ marginTop: '20px', marginBottom: '8px' }}>
          <Alert severity="error">{error}</Alert>
        </div>
      )}
      <Card className={resourceStyles.formSection} style={{ marginTop: '20px' }}>
        <PandadocSettingsSection disabled={disabled} />
      </Card>
    </>
  )
}
export default PandadocSettings
